import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import {
  ContractTerminationConfirmAction,
  ContractType,
} from '../../../../common/types'
import { resolveContractTerminationTerminology } from '../utils/resolveContractTerminationTerminology'

import { ResidentAppIllustration } from 'components/ResidentAppIllustration'
import Success from 'components/Success'

interface ConfirmSuccessProps {
  contractType: ContractType
}

export const ConfirmSuccess: React.FC<ConfirmSuccessProps> = ({
  contractType,
}) => {
  const { t } = useTranslation(['common', 'terminateContract'])
  const [params] = useSearchParams()

  const action = params.get('action') as ContractTerminationConfirmAction
  const terminology = resolveContractTerminationTerminology(contractType)

  return (
    <Success
      illustration={
        <ResidentAppIllustration
          name={
            action === ContractTerminationConfirmAction.ACCEPT
              ? 'house-bye'
              : 'house-confused'
          }
          alt={t('common:alt.illustration')}
          className="-ml-2"
        />
      }
      heading={
        action === ContractTerminationConfirmAction.ACCEPT
          ? t('terminateContract:headings.thankYou')
          : t(terminology.confirmationRejectedHeading)
      }
      text={
        action === ContractTerminationConfirmAction.ACCEPT
          ? t(terminology.confirmationAcceptedText)
          : undefined
      }
    />
  )
}
